import React from "react";
import FilterSection from "./FilterSection";
import PrimaryOutlineButton from "./PrimaryOutlineButton";
import PrimaryButton from "./PrimaryButton";

const FilterPanel = ({
  filterData,
  handleReset,
  handleSelectionChange,
  selections,
  handleCancel,
  handleApply,
  className,
  style,
  isSidebar = true,
  showTitle = true
}) => {
  return (
    <div
      className={className || `w-full h-full bg-white flex flex-col ${!isSidebar ? "max-w-[300px] rounded-[10px] shadow-[0px_4px_16px_0px_#0000001F]" : ""}`}
      style={style}
    >
      {/* Header */}
      <div className="flex justify-between items-center p-4 !pb-0">
        <h2 className="text-[20px] text-black font-poppins font-[600]">
          {showTitle ? "Filters" : ""}
        </h2>
        <button
          onClick={handleReset}
          className="text-[#00ADEF] text-[16px] font-[500] font-poppins"
        >
          Reset
        </button>
      </div>

      {/* Scrollable Filters Content */}
      <div
        className="flex-1 flex flex-col gap-4 px-4 py-2 overflow-y-auto"
      >
        {/* Dynamically render filter sections */}
        {filterData.map((filter) => (
          <FilterSection
            key={filter.id}
            title={filter.title}
            options={filter.options}
            selected={selections[filter.id]}
            onChange={(value) => handleSelectionChange(filter.id, value)}
            multiSelect={filter.multiSelect || false}
            optionValueKey={filter.optionValueKey || null}
            optionLabelKey={filter.optionLabelKey || null}
            search={filter.search}
            handleSearchChange={filter.handleSearchChange}
            customContent={filter.customContent}
          />
        ))}
      </div>

      {/* Sticky Footer Buttons */}
      <div className="w-full flex gap-2 p-5 !pt-3 sticky bottom-0 bg-white shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)]">
        <PrimaryOutlineButton
          label={"Cancel"}
          className={
            "w-[50%] !font-nunito text-[14px] font-[600] px-2 !h-[34px] rounded-[5px]"
          }
          onClick={handleCancel}
        />
        <PrimaryButton
          className={
            "w-[50%] h-[34px] rounded-[5px] text-[14px] font-[600] !font-nunito"
          }
          label="Apply"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default FilterPanel;
